import React from 'react';
import * as S from './TaReview.styles';
import {Row} from './../../common/Layouts/Layouts';
import TaProgressBar from '../TaProgressBar/TaProgressBar';

const TaReview = ({taData}) => {
  const {hotelRating = 4, reviewCount = 0, ratingImageUrl = '', rwc = []} = taData;
  return (
    <Row>
      <S.TaReviewWrapDiv>
        <S.TripAdvisorTextWrapper>Trip Advisor</S.TripAdvisorTextWrapper>
        <S.TaAvgReviewTextWrapperDiv>
          <S.TaAvgReviewTextWrapper>{hotelRating}</S.TaAvgReviewTextWrapper>
          <S.TaTotalReviewTextWrapper>/5</S.TaTotalReviewTextWrapper>
        </S.TaAvgReviewTextWrapperDiv>
        <S.TaReviewCountTextWrapper>{reviewCount} Ratings</S.TaReviewCountTextWrapper>
        <S.TaReviewCountTextWrapper>
          <S.RatingImage src={ratingImageUrl} alt="Segment Image" />
        </S.TaReviewCountTextWrapper>
      </S.TaReviewWrapDiv>

      <TaProgressBar progressBarData={rwc}></TaProgressBar>
    </Row>
  );
};

export default TaReview;
